<template>
    <index-table-row :item="item" :can-selected="true">
        <index-table-cell class="text-center">
            <md-icon v-if="item.isFederatedUser" class="text-success">check</md-icon>
            <md-icon v-else class="text-danger md-icon-clear">clear</md-icon>
        </index-table-cell>
        <index-table-cell v-text="item.firstName" />
        <index-table-cell v-text="item.lastName" />
        <index-table-cell v-text="item.email" />
        <index-table-cell-bool :bool="Boolean(item.isActive)" />
        <index-table-cell class="text-center" v-for="(access, key) in item.accesses" :key="key">
            <div class="app-action" v-if="access.hasAccess && access.isActive">
                <md-icon class="text-success">check</md-icon>
                <md-button class="app-action-btn md-primary md-sm" @click.native="actionDeactivate(access.appSlug)">Deactivate
                </md-button>
            </div>
            <div class="app-action" v-else-if="access.hasAccess">
                <md-icon class="text-warning">priority_high</md-icon>
                <md-button class="app-action-btn md-primary md-sm" @click.native="actionActivate(access.appSlug)">Activate
                </md-button>
            </div>
            <div class="app-action" v-else>
                <md-icon class="text-danger md-icon-clear">clear</md-icon>
            </div>
            <user-pair-modal v-if="showModals[access.appSlug]" :app-slug="access.appSlug" :user="item" />
        </index-table-cell>
        <index-table-cell>
            <!--<md-button class="md-just-icon md-primary" @click.native="actionEdit">-->
            <!--    <md-icon>edit</md-icon>-->
            <!--</md-button>-->
            <user-more-dropdown :user="itemData" />
        </index-table-cell>
    </index-table-row>
</template>

<script>
import IndexTableRow from "../../components/Index/IndexTableRow";
import IndexTableCell from "../../components/Index/IndexTableCell";
import UserPairModal from "../../modals/UserPairModal";
import UserMoreDropdown from "./UserMoreDropdown";
import IndexTableCellBool from "../../components/Index/IndexTableCellBool";

export default {
    name: "UsersRow",
    components: {
        IndexTableCellBool,
        UserMoreDropdown,
        UserPairModal,
        IndexTableCell,
        IndexTableRow
    },
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showModals: {},
            itemData: this.item
        };
    },
    methods: {
        actionActivate(appSlug) {
            this.$api.activateAccount({
                data: {
                    app: appSlug,
                    authId: this.item.id
                }
            }).then(() => {
                let access = this.itemData.accesses.find(access => {
                    return access.appSlug === appSlug;
                });
                access.isActive = true;
            });
        },
        actionDeactivate(appSlug) {
            this.$api.deactivateAccount({
                data: {
                    app: appSlug,
                    authId: this.item.id
                }
            }).then(() => {
                let access = this.itemData.accesses.find(access => {
                    return access.appSlug === appSlug;
                });
                access.isActive = false;
            });
        },
        actionEdit() {
            let path = this.$enums.RoutePathEnum.USER_UPDATE;
            path = path.replace(":id", this.item.id);

            this.$router.push(path);
        }
    },
    watch: {
        item(value) {
            this.itemData = value;
        }
    }
};
</script>

<style lang="scss">
.app-action {
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 27px;
    width: 80px;

    .app-action-btn {
        display: none !important;
    }

    &:hover {
        .md-icon {
            display: none;
        }
        .md-icon-clear {
            display: inline-block !important;
        }

        .app-action-btn {
            display: inline-block !important;
            width: auto !important;
        }
    }
}
</style>
